export const LOBBY_MENU_LABEL = 'ห้องข้อความหลัก'
export const PRIVATE_CHAT_MENU_LABEL = 'ห้องข้อความส่วนตัว'
export const SESSION_MANAGEMENT_MENU_LABEL = 'ประวัติการบริการ'
export const DASHBOARD_MENU_LABEL = 'dashboard'
export const HOLDING_MESSAGE_MENU_LABEL = 'ห้องข้อความส่วนตัว'

export const USER_DETAIL_LABEL = 'ข้อมูลลูกค้า'
export const ACTIVITY_HISTORIES_LABEL = `ประวัติการให้บริการ`
export const TAGGING_LABEL = 'ข้อมูลกำกับการบริการ'